// pages/resources/Events.jsx
export default function Events() {
  const upcomingEvents = [
    {
      title: "Adsurg Summit 2026",
      date: "March 15, 2026",
      time: "9:00 AM - 5:00 PM IST",
      location: "Virtual Event",
      type: "Conference",
      attendees: "500+ Expected"
    },
    {
      title: "Mastering Google Ads Workshop",
      date: "February 20, 2026",
      time: "2:00 PM - 4:00 PM IST",
      location: "Online Webinar",
      type: "Workshop",
      attendees: "100+ Registered"
    },
    {
      title: "AI in Advertising Roundtable",
      date: "February 28, 2026",
      time: "11:00 AM - 12:30 PM IST",
      location: "Virtual Event",
      type: "Discussion",
      attendees: "50+ Expected"
    }
  ];

  const pastEvents = [
    {
      title: "Digital Advertising Masterclass 2025",
      date: "December 10, 2025",
      attendees: "750+ Attended",
      recording: true
    },
    {
      title: "E-commerce Advertising Deep Dive",
      date: "November 5, 2025",
      attendees: "320+ Attended",
      recording: true
    },
    {
      title: "Social Media ROI Workshop",
      date: "October 15, 2025",
      attendees: "180+ Attended",
      recording: true
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Events & Webinars
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Join our community events, workshops, and webinars to stay ahead in digital advertising
          </p>
        </div>

        {/* Upcoming Events */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
            <span className="w-2 h-8 bg-gradient-to-b from-[#00809D] to-[#00a0c4] rounded-full"></span>
            Upcoming Events
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {upcomingEvents.map((event, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-8 hover:border-[#00809D]/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#00809D]/20"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="px-3 py-1 bg-[#00809D]/20 text-[#00809D] rounded-full text-sm font-semibold">
                    {event.type}
                  </span>
                  <span className="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-xs font-semibold">
                    LIVE
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-[#00809D] transition-colors">
                  {event.title}
                </h3>

                <div className="space-y-3 mb-6 text-gray-400 text-sm">
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {event.date}
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {event.time}
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {event.location}
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    {event.attendees}
                  </div>
                </div>

                <button className="w-full bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-6 py-3 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50">
                  Register Now
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Past Events */}
        <div>
          <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
            <span className="w-2 h-8 bg-gradient-to-b from-gray-600 to-gray-800 rounded-full"></span>
            Past Events
          </h2>
          <div className="space-y-4">
            {pastEvents.map((event, index) => (
              <div
                key={index}
                className="bg-gradient-to-r from-gray-900 to-black border border-white/10 rounded-2xl p-6 hover:border-[#00809D]/50 transition-all duration-300"
              >
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-white mb-2">{event.title}</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-400">
                      <span>{event.date}</span>
                      <span>•</span>
                      <span>{event.attendees}</span>
                    </div>
                  </div>
                  <button className="bg-gray-800 text-white px-6 py-2 rounded-xl font-semibold hover:bg-gray-700 transition-all flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Watch Recording
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
